export default function () {
    document.addEventListener("DOMContentLoaded", () => {
        const faqWrappers = document.querySelectorAll("[data-faq-wrapper]");

        faqWrappers.forEach(wrapper => {
            const items = wrapper.querySelectorAll(".faq-item");

            items.forEach(item => {
                const button = item.querySelector(".faq-question");
                const answer = item.querySelector(".faq-answer");
                const icon = item.querySelector(".faq-icon");

                button.addEventListener("click", () => {
                    const isOpen = item.classList.contains("open");

                    if (isOpen) {
                        item.classList.remove("open");
                        answer.style.maxHeight = null;
                        icon.style.transform = "rotate(0deg)";
                    } else {
                        item.classList.add("open");
                        answer.style.maxHeight = answer.scrollHeight + "px";
                        icon.style.transform = "rotate(180deg)";
                    }
                });
            });
        });
    });


}